import React, {useCallback, useEffect, useState} from "react";
import {Avatar, IconButton} from "@mui/material";
import ChangeLanguageDialog from "./ChangeLanguageDialog";
import { LocalLanguage, getSupportedLanguages, getDefaultLanguage } from "../../data/LocalLanguage";
import { makeStyles } from 'tss-react/mui';
import {useTranslation} from "react-i18next";
import {simplifyLanguageSymbol} from "../../utils/LanguageSymbolSimplify";

const useStyles = makeStyles()(() => ({
    flag: {
        height: "20px",
        width: "20px",
    },
    iconButton: {
        marginRight: "10px",
        height: "40px",
        width: "40px",
        overflow: "visible"
    }
}));

const LocalLanguageSelection = () => {
    const languages = getSupportedLanguages()
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const { classes } = useStyles();
    const { i18n } = useTranslation();

    const getCurrentLanguage = useCallback(() => {
        const i18nLanguage = simplifyLanguageSymbol(i18n.language)
        return languages.filter(language => language.symbol === i18nLanguage)[0] ?? getDefaultLanguage()
    }, [languages, i18n.language])

    const [selectedLanguage, setSelectedLanguage] = useState<LocalLanguage>(getCurrentLanguage());

    // update selected language to rerender flag icon
    useEffect(() => {
        setSelectedLanguage(getCurrentLanguage())
    }, [getCurrentLanguage])

    const changeLanguage = (newLanguage: LocalLanguage) => {
        setSelectedLanguage(newLanguage);
        i18n.changeLanguage(newLanguage.symbol).then(() => {});
        setShowDialog(false)
    };

    return <>
        <IconButton
            onClick={() => {
                setShowDialog(true);
            }}
            className={classes.iconButton}
            data-cy={"headerLanguageButton"}
            size="large">
            <Avatar className={classes.flag}>
                {/* Pass SVG icon as component to prevent visible loading */}
                <selectedLanguage.image data-cy={"headerLanguageAvatar"}/>
            </Avatar>
        </IconButton>

        {
            showDialog &&
            <ChangeLanguageDialog
                isOpen={showDialog}
                languages={languages}
                onChange={changeLanguage}
                onCancel={() => setShowDialog(false)}
            />
        }
    </>;
};

export default LocalLanguageSelection;